import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';
import { IDefaultCommissionInfo, IDefaultCommissionLovs } from '.';
import { trimTrailingZeros } from '@utils/formatting-utils';
import PrecisionService from '@services/PrecisionService';

export const drawerSections = (
  values: IDefaultCommissionInfo,
  lovs: IDefaultCommissionLovs
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      assignedLine: {
        name: 'assignedLineId',
        title: 'Line',
        type: FormFieldType.text,
        placeholder: 'Line',
        value: values.assignedLineName,
        required: true,
        disabled: true,
      },
      commissionType: {
        name: 'commissionType',
        title: 'Commission Type',
        placeholder: 'Commission Type',
        type: FormFieldType.select,
        value: values.commissionType ?? 'RATE',
        required: true,
        selectOptions: lovs.commissionType,
      },
      lineCommissionValue: {
        name: 'lineCommissionValue',
        title: 'Commission',
        placeholder: 'Commission',
        type: FormFieldType.currency,
        value: values.lineCommissionValue,
        conditionalRequired: (values) => values.commissionType === 'VALUE',
        conditionalDisable: (values) => values.commissionType !== 'VALUE',
        conditionalHidden: (values) => values.commissionType !== 'VALUE',
      },
      valueCurrency: {
        name: 'valueCurrency',
        title: 'Commission Currency',
        placeholder: 'Commission Currency',
        type: FormFieldType.select,
        value: values.valueCurrency ?? '39735',
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
        conditionalRequired: (values) => values.commissionType === 'VALUE',
        conditionalDisable: (values) => values.commissionType !== 'VALUE',
        conditionalHidden: (values) => values.commissionType !== 'VALUE',
      },
      lineCommissionRate: {
        name: 'lineCommissionRate',
        title: 'Commission Rate',
        type: FormFieldType.percentage,
        placeholder: 'Commission Rate',
        value: trimTrailingZeros(
          PrecisionService.multiplyBy100(values.lineCommissionRate)
        ),
        conditionalRequired: (values) => values.commissionType !== 'VALUE',
        conditionalDisable: (values) => values.commissionType === 'VALUE',
        conditionalHidden: (values) => values.commissionType === 'VALUE',
      },
      applicableOn: {
        name: 'applicableOn',
        title: 'Commission Applicable On',
        placeholder: 'Commission Applicable On',
        type: FormFieldType.select,
        value: !isEmpty(values.applicableOn) ? values.applicableOn : '',
        conditionalRequired: (values) => values.commissionType !== 'VALUE',
        conditionalDisable: (values) => values.commissionType === 'VALUE',
        conditionalHidden: (values) => values.commissionType === 'VALUE',
        selectOptions: lovs.applicableOn,
      },
    },
  },
];
